import { Pipe, PipeTransform } from '@angular/core';
import { SaneNumberPipe } from '../core/sane-number.pipe';

export interface PercentValue {
  value: string;
}

/**
 * Two-way transformation between proportion and percent.
 */
@Pipe({ name: 'percentValue' })
export class PercentValuePipe implements PipeTransform {
  transform<K extends string>(source: { [T in K]: number | null }, key: K) {
    return {
      get value() {
        return source[key] != null
          ? new SaneNumberPipe().transform(+(source[key]! * 100))
          : '';
      },
      set value(value: string) {
        source[key] = value ? +value / 100 : null;
      },
    };
  }
}
